import type { SimActiveInfo } from "../types/sim";
import { formatClockTime, formatSimSpeed, formatTrackName } from "../types/sim";

interface SimBannerProps {
  active: boolean;
  info: SimActiveInfo | null;
}

/**
 * Persistent amber strip shown on every view while the in-server simulator
 * is publishing on the live topics, so nobody mistakes fake telemetry for
 * the car.
 */
export function SimBanner({ active, info }: SimBannerProps) {
  if (!active || !info) return null;

  const detail = `${info.scenario} on ${formatTrackName(info.track)} · ${formatSimSpeed(info.speed)} · ends ${formatClockTime(info.expiresAt)}`;

  return (
    <div className="sim-banner" role="status" aria-live="polite">
      <span className="sim-banner__title">SIMULATION</span>
      <span className="sim-banner__detail">{detail}</span>
    </div>
  );
}
